export default "__VITE_ASSET__6c5ac151__"